import React, { useState, useEffect } from 'react';
import './Header.css';

import { HeaderItem, MobileNavbar, Logo } from '../../components';
import { contactContent, navbar} from '../../constants';

import { FaFacebookF, FaInstagram, FaBars, FaTimes, FaSearch } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';

// 1. IMPORT HOOKA DO TŁUMACZEŃ
import { useTranslation } from 'react-i18next';
 
const Header = () => { 

  // 2. INICJALIZACJA TŁUMACZEŃ
  const { t, i18n } = useTranslation();

  const navigate = useNavigate(); 
  const { pathname } = useLocation();

  const [click, setClick] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  // 3. FUNKCJA ZMIANY JĘZYKA
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  /********** 1-Manage Sticky Header ***********/
  // Manage Sticky Header 
  useEffect(() => {
    window.addEventListener('scroll', stickyHeader);
    return () => {
      window.removeEventListener('scroll', stickyHeader);
    };
  });

  // Add active class to header on scroll
  const stickyHeader = (e) => {
    const header = document.querySelector('.header');
    const scrollTop = window.scrollY;
    scrollTop >= 60 ? header.classList.add('active') : header.classList.remove('active');
  };

  /********** 2-Manage On Scroll  ***********/
  // Manage On Scroll Functionality
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  // Handle scroll event
  const handleScroll = (e) => {
    /* Close Menubar On Scroll */
    const navbar = document.querySelector('.navbar');
    if (navbar) navbar.classList.remove('active'); // Zabezpieczenie przed nullem
    setClick(false);
    setOpen(false);
    setIsActive(false);
  };
  
  /********** 3-Manage Mobile Navbar ***********/
  // Handle click on menu button
  const handleClick = () => { 
    setIsActive(false);
    setClick((prevClick) => !prevClick);
    setOpen((prevOpen) => !prevOpen);
  };

  // Close the Navbar between navigation
  useEffect(() => {
    setOpen(false);
    setClick(false);
    setIsActive(false);
  }, [pathname]);

  /********** 4-Manage Search Functionality ***********/
  // Function to handle search icon click
  const handleSearchIconClick = () => {
    setIsActive(!isActive);
    if (!isActive) {
      setSearchValue('');
    }
  }; 

  // Function to handle search form submit
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchValue.trim() !== '') {
      navigate(`/blogs/search/${searchValue}`);
      setSearchValue(''); // Reset the search value to clear the input field
    }
  };

  // Function to handle search input change
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  // Reorder contacts based on your required sequence
  const orderedContacts = [ 
      contactContent.find(contact => contact.title === 'contact.call_us'),
      contactContent.find(contact => contact.title === 'contact.garden_name'),
      contactContent.find(contact => contact.title === 'contact.send_email'),
  ].filter(Boolean);

  return (
    <nav className='header'>

      {/* 1st Header Container */}
      <div className='header-1'>

        {/* Header contacts */}
        <ul className='header-contacts'>
          {orderedContacts.map((contact) => (
            <li key={contact.id}>
              <div className='icon'>{contact.icon}</div>
              <span className={contact.title.includes('email') ? 'gmail' : ''}>
                {t(contact.content[0])} {/* Show only the first item from content */}
              </span>
            </li>
          ))}
        </ul>

        {/* Social contacts & Language Switcher */}
        <div className='social-contacts' style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          
          {/* PRZEŁĄCZNIK JĘZYKA */}
          <div style={{ display: 'flex', gap: '5px', alignItems: 'center', color: 'inherit' }}>
            <button 
              onClick={() => changeLanguage('pl')}
              style={{ 
                background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', fontSize: 'inherit',
                fontWeight: i18n.language === 'pl' ? 'bold' : 'normal',
                opacity: i18n.language === 'pl' ? 1 : 0.7
              }}
            >
              PL
            </button>
            <span>|</span>
            <button 
              onClick={() => changeLanguage('en')}
              style={{ 
                background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', fontSize: 'inherit',
                fontWeight: i18n.language === 'en' ? 'bold' : 'normal',
                opacity: i18n.language === 'en' ? 1 : 0.7
              }}
            >
              EN
            </button>
          </div>

          <a href="https://www.facebook.com/profile.php?id=61584478547291&locale=pl_PL"><FaFacebookF className='icon' /></a>
          <a href="https://www.instagram.com/dwor.imielno?igsh=cmkxM2M0bWR0cTZj"><FaInstagram className='icon' /></a>
        </div>

      </div>

      {/* 2nd Header Container */}
      <div className='header-2'>

        {/* Logo */}
        <Logo />

        {/* Mobile Navbar */}
        <MobileNavbar isOpen={isOpen} />
 
        <div className='container'>

          {/* Desktop Navbar */}
            <div className='navbar'>
              {
                navbar.map((item) => {
                  return <HeaderItem key={item.id} {...item} />
                })
              } 
            </div>  

          {/* Header Icons Container */}
          <div className='icon-container'>
            <div id="search" className={`icon fa-solid fa-magnifying-glass ${isActive ? 'active' : ''}`} onClick={handleSearchIconClick}><FaSearch className='icon' /></div>
            <div className='icon menu-btn' onClick={handleClick}>{click ? <FaTimes /> : <FaBars />}</div> {/* Menu Button */}
          </div>

        </div>

        {/* Search Container */}
        <form onSubmit={handleSearchSubmit} className={`search-container ${isActive ? 'active' : ''}`}>
          {/* UŻYCIE TŁUMACZENIA W POLU WYSZUKIWARKI */}
          <input type='text' id='search' placeholder={t('header.searchPlaceholder')} value={searchValue} onChange={handleSearchChange} required /> {/* Search Input */}
          <button type="submit"><FaSearch className='icon' /></button> {/* Search Button */}
        </form>
        
      </div>

    </nav>
  );
}

export default Header;